import * as React from 'react';
import classNames from 'classnames';

function TabChevron(_a) {
    var _b;
    var direction = _a.direction;
    return (React.createElement("div", { className: classNames('nv-icon-tab-chevron', (_b = {},
            _b['nv-icon-tab-chevron--left'] = direction === 'left',
            _b)) },
        React.createElement("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24ZM17.5113 12.8226L10.9548 19.379C10.5 19.8339 9.76452 19.8339 9.31452 19.379L8.49193 18.5565C8.0371 18.1016 8.0371 17.3661 8.49193 16.9161L13.4081 12L8.49193 7.08387C8.0371 6.62903 8.0371 5.89355 8.49193 5.44355L9.31452 4.62097C9.76935 4.16613 10.5048 4.16613 10.9548 4.62097L17.5113 11.1774C17.9661 11.6323 17.9661 12.3677 17.5113 12.8226Z", fill: "#128279" }))));
}

export { TabChevron as default };
//# sourceMappingURL=TabChevron.esm.js.map
